export const REDIRECT_BANK_LINK = "REDIRECT_BANK_LINK";
export const REDIRECT_BANK_LINK_SUCCESS = "REDIRECT_BANK_LINK_SUCCESS";
export const REDIRECT_BANK_LINK_FAIL = "REDIRECT_BANK_LINK_FAIL";